/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function( $ ) {
	
	var SidebarMenu = {};

	SidebarMenu.init = function() {
		var menus = $( '.aside-list ul.menu' );

		menus.each( function() {
			var items = $( this ).children( 'li' );
			
			items.each( function( index ) {
				if( index > 4 ) {
					$( this ).hide();
				}
			} );
		} );
	};
	
	SidebarMenu.toggle = function( menu ) {
		var items = menu.children( 'li' );
			
		items.each( function() {
			$( this ).show();
		} );
	};

	$( document ).ready( function() {
		SidebarMenu.init();
		
		$( '.show-all' ).click( function( e ) {
			e.preventDefault();
			
			var container = $( this ).parent( '.aside-list' );
			var menu = container.find( 'ul.menu' );
			
			SidebarMenu.toggle( menu );
			
			$( this ).hide();
			$( this ).siblings( '.show-less' ).show();
		} );
		
		$( '.show-less' ).click( function( e ) {
			e.preventDefault();
			
			SidebarMenu.init();
			
			$( this ).hide();
			$( this ).siblings( '.show-all' ).show();
		} );
	} );
	
})( jQuery );